module.exports = __webpack_public_path__ + "static/img/videoElectric-ok2.b7de024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/videoElectric-ok2.jpg
// module id = tBEY
// module chunks = 1